const baseTable = [
    { tableNane: '实际', tableName: 'actual_load_unload_result_stream' },
    // { tableNane: '预报', tableName: 'actual_forecast_result' },
    { tableNane: '计划', tableName: 'route_plan_result_stream' },
    // { tableNane: '最优', tableName: 'route_plan_optimal_result' },
]

export default baseTable
